import { IAB_ORG } from '../assets/data/taxonomies';

export default {
  getTopLevelGenres() {
    return IAB_ORG.filter(genre => !genre.parent && !isNaN(parseInt(genre.taxonomy_id, 10)));
  },
  getSupportedGenres() {
    // eslint-disable-next-line max-len
    return ['action', 'adventure', 'animals', 'animated', 'anime', 'children', 'comedy', 'crime', 'documentary', 'drama', 'educational', 'fantasy', 'faith', 'food', 'fashion', 'gaming', 'health', 'history', 'horror', 'miniseries', 'mystery', 'nature', 'news', 'reality', 'romance', 'science', 'fiction', 'sitcom', 'special', 'sports', 'thriller', 'technology'];
  }

};



// WEBPACK FOOTER //
// ./src/services/genreService.js